import React from "react";

const ChartSkeleton = ({ bars = 6 }) => {
  const heights = React.useMemo(() => {
    const seed = bars;
    return Array.from({ length: seed }, (_, i) => {
      const wave = Math.sin((i + 1) * 1.3) * 0.5 + 0.5;
      return Math.round(35 + wave * 55);
    });
  }, [bars]);

  return (
    <div className="rdc-chart-skeleton" aria-hidden="true">
      <div className="rdc-chart-skeleton__bars">
        {heights.map((h, i) => (
          <div
            key={i}
            className="rdc-skeleton rdc-chart-skeleton__bar"
            style={{ height: `${h}%` }}
          />
        ))}
      </div>
    </div>
  );
};

export default ChartSkeleton;
